import _find from 'lodash/find';
import onChange from '../../../dependencies/on-change/on-change';
import template from './attendances-by-group.html';
import viewAttendancesTemplate from './../view-attendances/view-attendances.html';

class AttendancesComponent {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, moment,
    StudentService,
    GroupService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.moment = moment;
    this.StudentService = StudentService;
    this.GroupService = GroupService;

    this.attendances = [];
    this.students = [];
    this.group = {};
  }

  $onChanges(changes) {
    if (changes.groups) {
      this.groups = Object.assign([], this.groups);
    }

    if (changes.me) {
      this.me = {...this.me};
    }

    if (changes.categoriesOfDeparture) {
      this.categoriesOfDeparture = Object.assign([], this.categoriesOfDeparture);
    }
  }

  getStudents(form) {
    if (form.$invalid) {
      return false;
    }

    this.GroupService.getStudents(this.group.id, true).then(result => {
      this.students = result;
      if (this.students.length === 0) {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Brak uczniów w wybranej grupie')
            .position('bottom right')
            .hideDelay(3000)
        );
      }
    });
  }

  getStudent(id) {
    return _find(this.students, student => student.id === id);
  }

  showAttendaces(studentId, ev) {
    const student = this.getStudent(studentId);
    this.getAttendances(studentId).then(result => {
      this.attendances = result;
      const dialogRender = onChange({
        isRendered: false
      }, function (path, value, prevValue) {
        this.callback(path, value, prevValue);
      });
      if (this.attendances.length > 0) {
        this.$mdDialog.show({
          bindToController: true,
          controllerAs: 'ctrl',
          controller: 'ViewAttendancesController',
          template: viewAttendancesTemplate,
          locals: {
            attendances: this.attendances,
            dialogRender,
            student,
            me: this.me,
            categoriesOfDeparture: this.categoriesOfDeparture
          },
          clickOutsideToClose: true,
          targetEvent: ev,
          onComplete: () => {
            dialogRender.isRendered = true;
          }
        });
      } else {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Wybrany uczeń nie posiada frekwencji')
            .position('bottom right')
            .hideDelay(3000)
        );
      }
    })
      .catch(() => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Nie udało się pobrać frekwencji')
            .position('bottom right')
            .hideDelay(3000)
        );
      });
  }

  getAttendances(studentId) {
    return this.StudentService.getAttendancesByStudent(studentId);
  }
}

export const Attendances = {
  bindings: {
    groups: '<',
    me: '<',
    categoriesOfDeparture: '<'
  },
  template,
  controller: AttendancesComponent
};
